import * as React from 'react';

import cx from 'classnames';

interface PublicCMSLayoutProps {
  additionalClassNames?: string;
  children: React.ReactNode;
}

export const PublicCMSLayout = ({ additionalClassNames, children }: PublicCMSLayoutProps) => {
  return (
    <div className={cx('h-background--navy-200', additionalClassNames)}>
      <div className="h-container--small">{children}</div>
    </div>
  );
};
